export default "__VITE_ASSET__Dtwiv1Vw__"